
import { getQueryVariable } from "Utils/utils";

export function getPlatform() {
  /*
    PhantomOnline
    Phantom
    FoxitReader
    MacPhantom
  */
  let platform = '', asyncCall = false;
  do {
    platform = getQueryVariable('platform');
    if ((window.qt && window.qt.webChannelTransport)) {
      asyncCall = true;
    }
    if ( window.webkit && window.webkit.messageHandlers && 
      window.webkit.messageHandlers.DispatchFunAsync && window.webkit.messageHandlers.DispatchFunAsync.postMessage) {
      if (!platform) platform = 'MacPhantom'; 
      asyncCall = false;
    } else if ( window.webkit && window.webkit.messageHandlers && 
      window.webkit.messageHandlers.DispatchFun && window.webkit.messageHandlers.DispatchFun.postMessage) {
      asyncCall = true;
      platform = 'IOS'; 
      break;
    }
    //console.log('platform', platform, asyncCall, window.webkit.messageHandlers)
    if(platform){
      break;
    }

    if (parent && parent.window && parent.window.platform === 'PhantomOnline') {
      platform = 'PhantomOnline'; break;
    }
    if (window.external && window.external.platform) {
      platform = window.external.platform; break;
    }
    if (window.external && window.external.getPlatform) {
      platform = window.external.getPlatform(); break;
    }
    if (window.qt && window.qt.webChannelTransport) {
      asyncCall = true;
      platform = 'Lite'; break;
    }
  } while (false);

  if (!platform)
    platform = 'platformSeven';

  return {platform, asyncCall}
}

export function loadqwebchannel(cb) {
  loadScript('./qwebchannel.js', function () {
    new QWebChannel(window.qt.webChannelTransport, function (channel) {
      window.external = channel.objects.external;
      cb && cb();
    });
  });
}

window.loadqwebchannel = loadqwebchannel;

export function loadScript(src, opts, cb) {
  const stdOnEnd = (script, cb) => {
    script.onload = function () {
      this.onerror = this.onload = null
      cb(null, script)
    }
    script.onerror = function () {
      // this.onload = null here is necessary
      // because even IE9 works not like others
      this.onerror = this.onload = null
      cb(new Error('Failed to load ' + this.src), script)
    }
  }
  const ieOnEnd = (script, cb) => {
    script.onreadystatechange = function () {
      if (this.readyState != 'complete' && this.readyState != 'loaded') return
      this.onreadystatechange = null
      cb(null, script) // there is no way to catch loading errors in IE8
    }
  }
  const setAttributes = (script, attrs) => {
    for (let attr in attrs) {
      script.setAttribute(attr, attrs[attr]);
    }
  }

  let head = document.head || document.getElementsByTagName('head')[0]
  let script = document.createElement('script')

  if (typeof opts === 'function') {
    cb = opts
    opts = {}
  }

  opts = opts || {}
  cb = cb || function () { }

  script.type = opts.type || 'text/javascript'
  script.charset = opts.charset || 'utf8';
  script.async = 'async' in opts ? !!opts.async : true
  script.src = src

  if (opts.attrs) {
    setAttributes(script, opts.attrs)
  }

  if (opts.text) {
    script.text = '' + opts.text
  }

  let onend = 'onload' in script ? stdOnEnd : ieOnEnd
  onend(script, cb)

  // some good legacy browsers (firefox) fail the 'in' detection above
  // so as a fallback we always set onload
  // old IE will ignore this and new IE will set onload
  if (!script.onload) {
    stdOnEnd(script, cb);
  }

  head.appendChild(script)
}

